import { isObject } from '../utils';

export function valueIn(givenValue: any, expectedValue: any): boolean {
  if (isObject(expectedValue)) {
    return Object.values(expectedValue).includes(givenValue);
  }

  if (Array.isArray(expectedValue) || typeof expectedValue === 'string') {
    return expectedValue.indexOf(givenValue) > -1;
  }

  throw new Error(
    `In operator: Unsupported values to compare ${JSON.stringify(
      givenValue,
    )}, ${JSON.stringify(expectedValue)}`,
  );
}
